import { RootState } from 'store';

const BudgetServices = (state: RootState) => state.supportAtHome.budgetServices;

export const selectBudgetServices = (state: RootState) => BudgetServices(state).rows;
export const selectBudgetServicesLoading = (state: RootState) => BudgetServices(state).loading;
